<script>
import QuizPlaceholder from "./QuizPlaceholder";
export default {
  name: "QuizPergunta",
  props: ["index", "perguntaArray", "spots"],
  components: {
    QuizPlaceholder
  },
  data() {
    return {};
  },
  mounted() {},

  computed: {},
  methods: {
    handleClick(event) {
      this.$emit("placeholderClick", event);
    }
  },
  render(createElement) {
    const perguntaArray = this.perguntaArray;
    let slotCounter = 0;

    const children = perguntaArray.reduce((acc, item) => {
      if (item === "???") {
        let propText = this.spots[slotCounter];
        slotCounter++;

        return [
          ...acc,
          createElement(
            QuizPlaceholder,
            {
              props: { text: propText, counter: slotCounter },

              on: {
                placeholderClick: this.handleClick
              }
            },
            item
          )
        ];
      }
      return [...acc, item + " "];
    }, []);

    return createElement("div", children);
  }
};
</script>
